import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import styles from "./About.module.css";
import { testUrl } from "../home/BaseData";
import universityImg from "./assets/imgs/university_building.png";

export const AboutPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await axios.get(`${testUrl}/api/dropdowns/about/`);
                setData(response.data);
            } catch (error) {
                console.error("Error fetching about data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAboutData();
    }, []);

    const currentLang = i18n.language || "uz";
    const title = data ? data[`site_title_${currentLang}`] : t("about_university");
    const image = data?.image1 ? data.image1 : universityImg;
    const historyHtml = data ? data[`site_details_${currentLang}`] : null;
    const quote = data ? data[`quote_${currentLang}`] : t("about_quote");
    const author = data ? data[`author_${currentLang}`] : t("about_quote_author");

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <p>{t("loading")}</p>
            </div>
        );
    }

    return (
        <div className={styles.mainContainer}>
            <div className={styles.contentWrapper}>
                {/* Hero Image Section */}
                <div className={styles.heroSection} data-aos="fade-down">
                    <img src={image} alt="University" className={styles.heroImage} />
                </div>

                <div className={styles.container}>
                    {/* Centered Main Title */}
                    <h1 className={styles.mainTitle} data-aos="fade-up">
                        {title ? title.toUpperCase() : ""}
                    </h1>

                    {/* Professionally Styled Quote */}
                    {(quote || author) && (
                        <div className={styles.quoteSection} data-aos="fade-up">
                            {quote && (
                                <div
                                    className={styles.quoteText}
                                    dangerouslySetInnerHTML={{ __html: quote.startsWith('<') ? quote : `“${quote}”` }}
                                />
                            )}
                            {author && (
                                <div className={styles.quoteFooter}>
                                    <div
                                        className={styles.quoteAuthor}
                                        dangerouslySetInnerHTML={{ __html: author }}
                                    />
                                </div>
                            )}
                        </div>
                    )}

                    {/* Main Content Area (Centralized) */}
                    <div className={`${styles.mainText} ck-content`} data-aos="fade-up">
                        {historyHtml ? (
                            <div dangerouslySetInnerHTML={{ __html: historyHtml }} />
                        ) : (
                            typeof t("historyofAlmazar") === "string" ?
                                t("historyofAlmazar").split(/\\n|\n/).map((p, i) => (
                                    p.trim() && <p key={i}>{p.trim()}</p>
                                )) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};